import React from "react";

function NotFound() {
  return (
    <div>
      <p>Page not found</p>
    </div>
  );
}

export default NotFound;
